/* Renders Login page */

import React from 'react';
import { Box } from '@material-ui/core';
import { LogoSvg, LogoLabelledBy } from '../utilities/SvgIcons';
import { LoginStyle } from '../../styles/LoginStyle';

const LoginLogo = () => {
    const classes = LoginStyle();

    return (
        <Box className={classes.logo}>
            <LogoSvg aria-labelledby={LogoLabelledBy} />
        </Box>
    );
};

export default LoginLogo;
